import Hero from "@/components/ui/Hero";
import PhotoUploader from "@/components/forms/PhotoUploader";
import Reveal from "@/components/ui/Reveal";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function UploadPhotos() {
    useDocumentTitle(
        "Upload Photos for Estimate Review · Naples FL · A1 Screening",
        "Send a few photos of your pool cage, lanai, or screen damage and A1 Screening will follow up during business hours. Final recommendations and pricing are confirmed after technician review."
    );
    return (
        <>
            <Hero
                eyebrow="Estimate Review"
                title="Send Us a Few Photos"
                subtitle="Photos help A1 Screening understand the project before follow-up. Final recommendations and pricing are confirmed after technician review."
            />
            <section className="a1-section">
                <div className="a1-container max-w-2xl">
                    <Reveal>
                        <PhotoUploader />
                    </Reveal>
                </div>
            </section>
        </>
    );
}
